import {UI, styleRule, StyleSheet, registerStyle} from "../../stem-core/src/ui/UI";
import {Theme} from "../../stem-core/src/ui/style/Theme";
import {isFacebookBrowser, isSmallScreen} from "../Utils";
import {Device} from "../../stem-core/src/base/Device";
import {TEST_MODE} from "../Constants";
import {WidgetClose} from "../SVGElements";
import {MessageElement} from "../widget/ui/MessageElement";


export class ToastStyle extends StyleSheet {
    transitionTime = 150;

    @styleRule
    toast = {
        padding: () => Device.isMobileDevice() ? 12 : "12px 18px",
        borderRadius: this.themeProps.MERCHANT_BUTTON_INPUT_TOAST_BORDER_RADIUS,
        background: this.themeProps.TOAST_BACKGROUND,
        color: this.themeProps.TOAST_COLOR,
        position: "fixed",
        display: "table",
        bottom: () => (isSmallScreen() ? 14 : 48),
        margin: "auto",
        left: "50%",
        transition: this.transitionTime / 1000 + "s ease",
        transform: "translate(-50%, 96px)",
        opacity: 0,
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_NORMAL,
        zIndex: 12000,
        minWidth: this.themeProps.FIT_CONTENT,
        width: () => isFacebookBrowser() ? "" : this.themeProps.FIT_CONTENT,
        textAlign: "center",
    };

    @styleRule
    visible = {
        opacity: 1,
        transform: "translate(-50%, 0)",
    };

    @styleRule
    action = {
        display: "inline",
        marginLeft: 21,
        color: this.themeProps.TOAST_ACTION_COLOR,
        cursor: "pointer",
    };

    @styleRule
    message = {
        display: "inline-block",
    };

    @styleRule
    closeIcon = {
        marginLeft: 8,
        display: "inline-block",
        cursor: "pointer",
    }
}

@registerStyle(ToastStyle)
export class Toast extends UI.Element {
    active = null;
    hideTimeout = null;

    getDefaultOptions() {
        return Object.assign({}, super.getDefaultOptions(), {
            /* TODO: Some toast messages get pretty long. So either choose shorter messages, or find a way to determine
                a more appropriate timeout for longer messages. */
            visibleTimeout: 3000,
            showClose: false,
            action: null, // The format is {label, callback}
        });
    }

    static show(message, options) {
        if (Toast.active) {
            Toast.active.remove();
        }
        Toast.active = this.create(document.body, Object.assign({}, options, {message}));
        return Toast.active;
    }

    static showError(errorMessage) {
        const ERROR_OPTIONS = {style: {background: Theme.props.MERCHANT_ERROR}};
        this.show(errorMessage.message || errorMessage, ERROR_OPTIONS);
    }

    static showSuccess(message) {
        const SUCCESS_OPTIONS = {style: {background: Theme.props.MERCHANT_SUCCESS}};
        this.show(message, SUCCESS_OPTIONS);
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.toast);
    }

    render() {
        const {styleSheet} = this;
        const {action, message, showClose} = this.options;

        return [
            <MessageElement message={message} className={styleSheet.message}/>,
            action ? <div className={styleSheet.action}
                          onClick={() => {action.callback(); this.removeAnimated();}}>{action.label}</div> : null,
            showClose ? <WidgetClose color={styleSheet.themeProps.TOAST_COLOR} className={styleSheet.closeIcon}
                                     onClick={() => this.constructor.hide(this)}/> : null,
        ];
    }

    static hide(instance=null) {
        if (Toast.active && Toast.active === instance) {
            Toast.active.removeAnimated();
        }
        return instance;
    }

    remove() {
        clearTimeout(this.hideTimeout);
        this.node.remove();
        delete this;
    }

    removeAnimated() {
        this.removeClass(this.styleSheet.visible);
        setTimeout(() => {
            this.remove();
        }, this.styleSheet.transitionTime);
    }

    onMount() {
        setTimeout(() => {
            this.addClass(this.styleSheet.visible);
        }, 100);

        if (this.options.visibleTimeout) {
            const toastVisibleTime = (TEST_MODE ? 2 : 1) * (this.options.visibleTimeout + this.styleSheet.transitionTime);
            this.hideTimeout = setTimeout(() => this.constructor.hide(this), toastVisibleTime);
        }
    }
}
